export default __webpack_public_path__ + "static/media/Develop.27b00420.svg";